<div
    class="flex flex-col justify-start items-center gap-4 bg-oatmilk font-inter w-40 p-4 pointer-events-auto">
    <div class="flex flex-col justify-start items-center gap-2">
        <div class="flex flex-col justify-start items-center gap-1">
            <fm-avatar
                size="xxl"
                [isSaved]="data.partner?.saved"
                [avatarLocation]="data.partner?.profilePhoto" />
            <div
                class="font-semibold text-14 text-bluegrey leading-[17px] text-center text-ellipsis overflow-hidden line-clamp-1"
                >{{ data.partner?.displayName }}</div
            >
        </div>
        <div class="text-12 text-bluegrey-2 font-medium leading-[15px] w-full text-center">
            <div
                >{{ data.partner?.completedSessions }}
                {{ data.partner?.completedSessions == 1 ? 'session' : 'sessions' }}
            </div>
            <div>{{ data.partner?.timezone }}</div>
        </div>

        @if (sharedGroups.length > 0) {
            <div class="flex flex-row justify-center items-center gap-0.5">
                @for (group of sharedGroups; track group.groupId; let i = $index) {
                    @if (i < 2) {
                        <!-- Max 2 logos -->
                        <fm-group-avatar [avatarLocation]="group.groupLogo" />
                    }
                }
                @if (sharedGroups.length > 2) {
                    <div
                        class="bg-white text-bluegrey-2 text-10 font-medium h-6 w-6 rounded flex item-center justify-center leading-[24px] text-center"
                        >+{{ sharedGroups.length - 2 }}</div
                    >
                }
            </div>
        }
    </div>

    <p-button
        (click)="onClickViewProfile()"
        size="small"
        styleClass="!h-6 !rounded"
        label="View profile"
        [outlined]="true"
        severity="primary" />
</div>
